import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';

import attachScript from 'widget/player-widget/utils/attach-script';
//import { stringify } from 'utils/query-string';


const scriptApiUrl = 'https://connect.facebook.net/en_US/sdk.js';
let scriptPromise = null;


export default class FacebookExternal extends React.Component {

  static propTypes = {
    src: React.PropTypes.string.isRequired,
    onPlay: React.PropTypes.func,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    className: React.PropTypes.string,
    simple: React.PropTypes.bool,
    mobileMode: React.PropTypes.bool,
    showControls: React.PropTypes.bool,
    paused: React.PropTypes.bool,
    loop: React.PropTypes.bool,
    muted: React.PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.player = null;

    this.state = {
      isReady: false,
    };
  }

  componentDidMount() {
    window.fbAsyncInit = this.fbAsyncInit;

    // load once
    if (this.isScriptLoaded) {
      this.fbAsyncInit();
    } else if (!scriptPromise) {
      scriptPromise = attachScript(scriptApiUrl);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src === this.props.src) {
      this.setSettings(nextProps, this.props);
    } else {
      this.setState({ isReady: false });
    }
  }

  componentDidUpdate(prevProps) {
    const propsToPick = ['src', 'width', 'height'];
    const prev = _.pick(prevProps, propsToPick);
    const current = _.pick(this.props, propsToPick);

    if (!_.isEqual(prev, current)) {
      this.fbAsyncInit();
    }
  }

  componentWillUnmount() {
    window.fbAsyncInit = null;
    window.FB.Event.unsubscribe('xfbml.ready', this.handleFacebookReady);
  }

  didSubscribe = false;

  get isScriptLoaded() {
    return _.has(window, 'FB');
  }

  @autobind
  fbAsyncInit() {
    window.FB.init({
      xfbml: true,
      version: 'v2.5',
    });

    if (this.didSubscribe) {
      return;
    }

    window.FB.Event.subscribe('xfbml.ready', this.handleFacebookReady);
    this.didSubscribe = true;
  }

  @autobind
  handleFacebookReady(message) {
    if (message.type === 'video') {
      this.onReady(message.instance);
    }
  }

  @autobind
  onReady(player) {
    this.player = player;
    this.setState({ isReady: true });
    this.setSettings(this.props);
  }

  setSettings({ paused, muted }, prevProps = {}) {
    if (!this.player || !this.state.isReady) {
      return null;
    }

    if (prevProps.paused !== paused) {
      this.togglePaused(paused);
    }

    this.toggleMute(muted);
  }

  togglePaused(paused) {
    if (paused) {
      this.player.pause();
    } else {
      this.player.play();
    }
  }

  toggleMute(muted) {
    if (muted) {
      this.player.mute();
    } else {
      this.player.unmute();
    }
  }

  render() {
    const { src, className, width, height } = this.props;

    return (
      <div className={classnames('fb-video', className)}
           data-href={src}
           data-width={Math.ceil(width)}
           data-height={Math.ceil(height)}
           data-allowfullscreen="true" />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/video/external/facebook.js